import * as tslib_1 from "tslib";
import { getTranslations, isWorker } from '@wix/wixstores-client-core/dist/es/src/viewer-script/utils';
import { defaultQuantity, MULTILINGUAL_TO_TRANSLATIONS_MAP, PRODUCT_PAGE_APP_NAME, trackEventMetaData, translationPath, } from '../constants';
import { ProductService } from '../services/ProductService';
import { QuantityCalculator } from '../services/products/quantityCalculator';
import { inStock, userInputsFactory } from '../services/products/producUtils';
import * as _ from 'lodash';
import { APP_DEFINITION_ID, PageMap, PubSubEvents, STORAGE_PAGINATION_KEY, StoresWidgetID, } from '@wix/wixstores-client-core/dist/es/src/constants';
import { all, capitalizeFirstLetters, stripHtmlTags } from '../commons/utils';
import { PubSubManager } from '@wix/wixstores-client-core/dist/es/src/pub-sub-manager/pubSubManager';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import { parseUrl } from '@wix/native-components-infra/dist/src/urlUtils';
import UrlParser from '@wix/wixstores-client-core/dist/es/src/url-parser';
import { getFullSizedMediaUrl } from '@wix/wixstores-client-core/dist/es/src/media/mediaService';
import { ImageModeValues } from '@wix/wixstores-client-core/dist/es/src/media/constants';
import { updateWixCounters } from '../services/countersApi';
import { SeoProductBuilder, } from '@wix/wixstores-client-core/dist/es/src/builders/SeoItemData.builder';
import { queryToString } from '../services/urlUtils';
var ProductPageStore = /** @class */ (function () {
    function ProductPageStore(styleParams, origPublicData, setProps, siteStore, externalId, compId, reportError) {
        var _this = this;
        this.styleParams = styleParams;
        this.origPublicData = origPublicData;
        this.setProps = setProps;
        this.siteStore = siteStore;
        this.externalId = externalId;
        this.compId = compId;
        this.reportError = reportError;
        this.media = [];
        this.userInputs = userInputsFactory();
        this.isStartReported = false;
        this.addedToCartSuccessfullyCounter = 0;
        this.onAppLoaded = function () {
            if (!isWorker() || (_this.siteStore.isInteractive() && _this.isStartReported)) {
                _this.fedopsLogger.appLoaded();
                if (_this.siteStore.isSiteMode()) {
                    _this.reportBIOnAppLoaded();
                    if (_this.siteStore.experiments.enabled('specs.stores.ProductPageCounter')) {
                        _this.reportToWiXCounters();
                    }
                }
                _this.isStartReported = false;
            }
        };
        this.onFocusTriggered = function () {
            _this.setProps({
                shouldFocusAddToCartButton: false,
                shouldFocusNewAddToCartButton: false,
            });
        };
        this.socialSharing = {
            onClick: function (data) {
                var socialSharingEventWithProduct = tslib_1.__assign({}, data, { productId: _this.product.id });
                return _this.siteStore.biLogger.socialButtons(socialSharingEventWithProduct);
            },
        };
        this.infoSection = {
            onActive: function (BIEvent) {
                var infoSectionEventWithProduct = tslib_1.__assign({}, BIEvent, { productId: _this.product.id });
                return _this.siteStore.biLogger.clickOnProductDetailsSf(infoSectionEventWithProduct);
            },
        };
        this.navigate = function (product) {
            _this.siteStore.navigate({
                sectionId: PageMap.PRODUCT,
                queryParams: undefined,
                state: product.partialUrl,
            });
        };
        this.handleUserInput = function (inputType, data, index) {
            if (data === void 0) { data = null; }
            _this.userInputs[inputType][index] = data;
            _this.updateSelections();
            _this.nextProps();
        };
        this.updateSelections = function () {
            _this.productService.options.updateSelections(_this.product, _this.userInputs.selection);
            _this.filterMedia();
        };
        this.nextProps = function (additionalProps) {
            if (additionalProps === void 0) { additionalProps = {}; }
            var nextProps = tslib_1.__assign({ quantityRange: _this.quantityRange, product: _this.product, selectedVariant: _this.productService.options.selectedVariant, userInputs: _this.userInputs }, additionalProps);
            _this.setProps(nextProps);
        };
        this.validate = function () {
            _this.nextProps({
                userInputErrors: _this.productService.validate(_this.userInputs),
            });
        };
        this.handleAddToCart = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var eventId, preventNavigationToCart;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isInvalid()) {
                            return [2 /*return*/];
                        }
                        this.fedopsLogger.interactionStarted('add-to-cart');
                        return [4 /*yield*/, all(this.reportAddToCartBI(), this.trackAddToCart())];
                    case 1:
                        _a.sent();
                        eventId = this.pubSubManager.subscribe('Minicart.DidClose', function () {
                            _this.setProps({
                                shouldFocusAddToCartButton: true,
                                shouldFocusNewAddToCartButton: Math.random(),
                            });
                            _this.pubSubManager.unsubscribe('Minicart.DidClose', eventId);
                        }, true);
                        if (this.siteStore.experiments.enabled('specs.stores.NewAddToCartButton')) {
                            preventNavigationToCart = !this.styleParams.booleans.productPage_openMinicart;
                        }
                        this.setProps({ addedToCartSuccessfully: this.addedToCartSuccessfullyCounter++ });
                        return [2 /*return*/, this.productService
                                .addToCart(this.product, this.userInputs, this.styleParams.booleans.productPage_openMinicart, preventNavigationToCart)
                                .then(function () { return _this.fedopsLogger.interactionEnded('add-to-cart'); })];
                }
            });
        }); };
        this.isInvalid = function () {
            var validations = _this.productService.validate(_this.userInputs);
            return Object.keys(validations).reduce(function (accValidation, currentKey) {
                var flag = validations[currentKey].some(function (value) { return value === true; });
                return accValidation || flag;
            }, false);
        };
        this.setPageMetaData = function () {
            if (!_this.siteStore.isSiteMode()) {
                return;
            }
            if (_this.siteStore.experiments.enabled('specs.stores.RenderPromoteSeoTags')) {
                var seoData = void 0;
                try {
                    seoData = JSON.parse(_this.product.seoJson);
                }
                catch (_a) {
                    //
                }
                var productWithPageUrl = tslib_1.__assign({}, _this.product, { pagUrl: _this.productUrl });
                var itemData = {
                    product: new SeoProductBuilder(productWithPageUrl, {
                        productPageBaseUrl: _this.sectionUrl,
                    }).get(),
                    legacySeoData: {
                        title: _this.product.seoTitle,
                        description: _this.product.seoDescription,
                    },
                };
                _this.siteStore.seo.renderSEOTags({
                    itemType: 'STORES_PRODUCT',
                    itemData: itemData,
                    seoData: seoData,
                });
            }
            else {
                var title = _this.product.seoTitle || _this.product.name;
                var description = stripHtmlTags(_this.product.seoDescription || _this.product.description);
                var addSiteName = !_this.product.seoTitle;
                var metaData = {
                    title: { text: title, addSiteName: addSiteName },
                    description: description,
                    jsonLd: _this.jsonLd(title, description),
                    metaTags: [],
                };
                if (_this.product.media.length > 0) {
                    metaData.metaTags = [{ property: 'og:image', content: getFullSizedMediaUrl(_this.product.media[0]) }];
                }
                // The promise not resolves: https://jira.wixpress.com/browse/WEED-17596
                //tslint:disable-next-line:no-floating-promises
                _this.siteStore.siteApis.setPageMetaData(metaData, _this.compId);
            }
        };
        this.jsonLd = function (title, description) {
            return {
                action: undefined,
                '@context': 'https://schema.org/',
                '@type': 'Product',
                name: title,
                image: _this.product.media.map(getFullSizedMediaUrl),
                description: description,
                sku: _this.product.sku,
                offers: {
                    '@type': 'Offer',
                    url: _this.productUrl,
                    priceCurrency: _this.siteStore.currency,
                    price: (_this.product.comparePrice || _this.product.price).toFixed(2),
                    availability: inStock(_this.product) ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
                },
            };
        };
        this.pagePath = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var siteStructure, path, navigatedFromPageId, page_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.siteStore.isSSR()) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.siteStore.siteApis.getSiteStructure()];
                    case 1:
                        siteStructure = _a.sent();
                        path = siteStructure.pages.filter(function (p) { return p.isHomePage; });
                        navigatedFromPageId = this.navigationContext.pageId;
                        if (navigatedFromPageId) {
                            page_1 = siteStructure.pages.find(function (p) {
                                var notHomepage = !p.isHomePage;
                                var notSelf = p.id !== _this.siteStore.siteApis.currentPage.id;
                                var matchRef = p.id === navigatedFromPageId;
                                return notHomepage && notSelf && matchRef;
                            });
                            if (page_1) {
                                page_1.name = capitalizeFirstLetters(page_1.name);
                                page_1.url = "" + this.siteStore.location.baseUrl + page_1.url;
                                path.push(page_1);
                            }
                        }
                        path.push({ name: this.product.name, url: null, isHomePage: false, id: null });
                        path[0].name = this.translations.BREADCRUMBS_HOME;
                        path[0].url = this.siteStore.location.baseUrl;
                        return [2 /*return*/, path];
                }
            });
        }); };
        this.pubSubManager = new PubSubManager(this.siteStore.pubSub);
        this.productService = new ProductService(siteStore, this.pubSubManager);
        this.navigationContext = this.getNavigationContext();
        this.publicData = _.cloneDeep(this.origPublicData);
        var fedopsAppName = "" + PRODUCT_PAGE_APP_NAME + (isWorker() ? '-ooi' : '');
        if (isWorker()) {
            if (this.siteStore.experiments.enabled('specs.stores.NewFedopsIntegration')) {
                var fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
                this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
                    appId: APP_DEFINITION_ID,
                    widgetId: StoresWidgetID.PRODUCT_PAGE,
                });
            }
            else {
                this.fedopsLogger = this.siteStore.fedopsFactory.create(fedopsAppName, {
                    isWidgetLogger: true,
                    isServerSide: this.siteStore.isSSR(),
                    appId: APP_DEFINITION_ID,
                    metasiteId: this.siteStore.msid,
                    widgetId: StoresWidgetID.PRODUCT_PAGE,
                });
            }
            this.fedopsLogger.appLoadStarted();
            this.isStartReported = true;
        }
        else {
            this.fedopsLogger = this.siteStore.fedopsFactory.create(fedopsAppName);
        }
        this.siteStore.location.onChange(function () {
            return _this.setInitialState().catch(_this.reportError);
        });
    }
    ProductPageStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, translations, _c, product, appSettings;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.siteStore.getSectionUrl(PageMap.PRODUCT)];
                    case 1:
                        _a.sectionUrl = (_d.sent()).url;
                        return [4 /*yield*/, all(this.getProductPageTranslations(), this.getInitialData()).catch(this.reportError)];
                    case 2:
                        _b = _d.sent(), translations = _b[0], _c = _b[1], product = _c.product, appSettings = _c.appSettings;
                        if (!product) {
                            return [2 /*return*/, this.setProps(tslib_1.__assign({ emptyState: true }, this.defaultProps))];
                        }
                        this.product = product;
                        this.media = product.media;
                        this.translations = translations;
                        this.multilingualService = new MultilingualService(this.publicData.APP || {}, appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        this.productService.updateOptions(this.product);
                        this.setInitialUserInputs();
                        this.siteStore.pubSub.publish(PubSubEvents.RELATED_PRODUCTS, [this.product.id], true);
                        return [4 /*yield*/, this.setInitialProps()];
                    case 3:
                        _d.sent();
                        return [4 /*yield*/, this.trackViewContent()];
                    case 4:
                        _d.sent();
                        this.setPageMetaData();
                        if (this.siteStore.isSSR()) {
                            this.fedopsLogger.appLoaded();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductPageStore.prototype.reportBIOnAppLoaded = function () {
        var type = this.styleParams.numbers.productPage_galleryImageMode === ImageModeValues.CROP
            ? "crop" /* CROP */
            : "fit" /* FIT */;
        var eventData = {
            isMobileFriendly: this.siteStore.isMobileFriendly,
            testName: 'product_page_loaded',
            is_eligible: true,
            type: type,
        };
        // tslint:disable no-floating-promises
        this.siteStore.biLogger.exposureEventForTests(eventData);
    };
    ProductPageStore.prototype.reportToWiXCounters = function () {
        // tslint:disable no-floating-promises
        updateWixCounters(this.siteStore, this.product.id, this.siteStore.uuid);
    };
    ProductPageStore.prototype.updatePublicData = function (newPublicData) {
        var _this = this;
        Object.keys(newPublicData.APP).forEach(function (key) {
            _this.publicData.APP[key] = newPublicData.APP[key];
        });
    };
    ProductPageStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.updatePublicData(newPublicData);
        this.styleParams = newStyleParams;
        this.multilingualService.setWidgetSettings(newPublicData.appSettings);
        this.setProps({
            texts: this.getTexts(),
        });
    };
    ProductPageStore.prototype.getTexts = function () {
        var _this = this;
        return Object.keys(MULTILINGUAL_TO_TRANSLATIONS_MAP).reduce(function (acc, translationKey) {
            var multiligualKey = MULTILINGUAL_TO_TRANSLATIONS_MAP[translationKey];
            var override = _this.multilingualService.get(multiligualKey);
            if (override) {
                acc[translationKey] = override;
            }
            return acc;
        }, tslib_1.__assign({}, this.translations));
    };
    ProductPageStore.prototype.setInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [{}, this.defaultProps];
                        _b = { emptyState: false, experiments: {
                                isNewMobileLayout: this.siteStore.experiments.enabled('specs.stores.NewMobileLayout'),
                                newAddToCartButton: this.siteStore.experiments.enabled('specs.stores.NewAddToCartButton'),
                                isUnifiedProductImage: this.siteStore.experiments.enabled('specs.stores.UnifiedProductImage'),
                                isSSRImageImprovements: this.siteStore.experiments.enabled('specs.stores.SSRImageImprovements'),
                                isEmbeddedScriptPlaceHolderEnabled: this.siteStore.experiments.enabled('specs.stores.EmbeddedScriptPlaceHolder'),
                            }, handleAddToCart: this.handleAddToCart, handleUserInput: this.handleUserInput, hasMultipleMedia: this.product.media.length > 1, hideNavigationUrls: !this.siteStore.isSiteMode(), infoSection: this.infoSection, isDesktop: this.siteStore.isDesktop(), isMobile: this.siteStore.isMobile(), isRTL: this.siteStore.isRTL(), isSSR: this.siteStore.isSSR(), isSEO: this.siteStore.seo.isInSEO(), navigate: this.navigate, onFocusTriggered: this.onFocusTriggered };
                        return [4 /*yield*/, this.pagePath()];
                    case 1:
                        props = tslib_1.__assign.apply(void 0, _a.concat([(_b.pagePath = _c.sent(), _b.pagination = this.getPrevNextProducts(), _b.product = this.product, _b.productUrl = this.productUrl, _b.quantityRange = this.quantityRange, _b.ravenUserContextOverrides = { id: this.siteStore.storeId }, _b.selectedVariant = this.productService.options.selectedVariant, _b.shouldFocusAddToCartButton = false, _b.shouldFocusNewAddToCartButton = false, _b.siteUrl = this.siteStore.location.baseUrl, _b.socialSharing = this.socialSharing, _b.texts = this.getTexts(), _b.userInputErrors = userInputsFactory(), _b.userInputs = this.userInputs, _b.validate = this.validate, _b.addedToCartSuccessfully = false, _b)]));
                        this.setProps(props);
                        this.setDelayedProps(); // to do: remove me #EE-17414
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProductPageStore.prototype, "defaultProps", {
        get: function () {
            return {
                onAppLoaded: this.onAppLoaded,
                isInteractive: this.siteStore.isInteractive(),
                cssBaseUrl: this.siteStore.baseUrls.productPageBaseUrl,
            };
        },
        enumerable: true,
        configurable: true
    });
    ProductPageStore.prototype.setDelayedProps = function (ms) {
        var _this = this;
        if (ms === void 0) { ms = 500; }
        setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.navigationContext = this.getNavigationContext();
                        _a = this.setProps;
                        _b = {};
                        return [4 /*yield*/, this.pagePath()];
                    case 1:
                        _a.apply(this, [(_b.pagePath = _c.sent(),
                                _b.pagination = this.getPrevNextProducts(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); }, ms);
    };
    ProductPageStore.prototype.setInitialUserInputs = function () {
        var textFieldsLength = this.product.customTextFields ? this.product.customTextFields.length : 0;
        var selection = this.product.options.reduce(function (acc, option, i) {
            var shouldPreselect = option.selections.length > 1;
            acc[i] = shouldPreselect ? null : option.selections[0];
            return acc;
        }, []);
        this.userInputs = {
            selection: selection,
            text: Array(textFieldsLength).fill(null),
            quantity: [defaultQuantity],
        };
        this.updateSelections();
    };
    ProductPageStore.prototype.getProductPageTranslations = function () {
        if (this.translationsPromise) {
            return this.translationsPromise;
        }
        this.translationsPromise = getTranslations(translationPath(this.siteStore.baseUrls.productPageBaseUrl, this.siteStore.locale));
        return this.translationsPromise;
    };
    ProductPageStore.prototype.reportAddToCartBI = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventData;
            return tslib_1.__generator(this, function (_a) {
                eventData = {
                    appName: 'productPageApp',
                    hasOptions: this.userInputs.selection.length > 0,
                    productId: this.product.id,
                    productType: this.product.productType,
                    origin: 'product-page',
                    isNavigateCart: this.productService.shouldNavigateToCart(),
                    quantity: Math.round(this.selectedQuantity),
                };
                return [2 /*return*/, this.siteStore.biLogger.clickOnAddToCartSf(eventData)];
            });
        });
    };
    ProductPageStore.prototype.trackAddToCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var variant, params;
            return tslib_1.__generator(this, function (_a) {
                variant = this.productService.options.selectedVariant || this.product;
                params = tslib_1.__assign({}, trackEventMetaData, { id: this.product.id, name: this.product.name, price: variant.comparePrice || variant.price, currency: this.siteStore.currency, quantity: this.selectedQuantity });
                return [2 /*return*/, this.siteStore.windowApis.trackEvent("AddToCart" /* AddToCart */, params)];
            });
        });
    };
    ProductPageStore.prototype.trackViewContent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = tslib_1.__assign({}, trackEventMetaData, { id: this.product.id, name: this.product.name, price: this.product.comparePrice || this.product.price, currency: this.siteStore.currency });
                return [2 /*return*/, this.siteStore.windowApis.trackEvent("ViewContent" /* ViewContent */, params)];
            });
        });
    };
    ProductPageStore.prototype.filterMedia = function () {
        var filteredMedia = _.flatMap(this.userInputs.selection, function (item) { return (item && item.linkedMediaItems) || []; });
        this.product.media = filteredMedia.length ? filteredMedia : this.media;
    };
    ProductPageStore.prototype.getUrlWithoutParams = function (url) {
        var parsedUrl = parseUrl(url);
        return parsedUrl.protocol + "://" + parsedUrl.host + parsedUrl.path;
    };
    ProductPageStore.prototype.getInitialData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product, appSettings, currentUrl, fetch_1, data, fetch_2, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentUrl = this.getUrlWithoutParams(this.siteStore.location.url);
                        if (!(((this.siteStore.isEditorMode() || this.siteStore.isPreviewMode()) && this.siteStore.location.path.length > 1) ||
                            (this.siteStore.isSiteMode() && currentUrl !== this.sectionUrl))) return [3 /*break*/, 2];
                        fetch_1 = this.productService.getProductBySlug(this.slug, this.externalId);
                        return [4 /*yield*/, fetch_1];
                    case 1:
                        data = _a.sent();
                        product = data.catalog.product;
                        appSettings = data.appSettings;
                        return [3 /*break*/, 4];
                    case 2:
                        fetch_2 = this.productService.getDefaultProduct(this.externalId);
                        return [4 /*yield*/, fetch_2];
                    case 3:
                        data = _a.sent();
                        product = data.catalog.products.list[0];
                        appSettings = data.appSettings;
                        _a.label = 4;
                    case 4: return [2 /*return*/, { product: product, appSettings: appSettings }];
                }
            });
        });
    };
    ProductPageStore.prototype.getPrevNextProducts = function () {
        var _this = this;
        var prevProduct = {};
        var nextProduct = {};
        var paginationMap = this.navigationContext.paginationMap;
        var getUrl = function (slug) {
            var prefix = _this.sectionUrl + "/" + slug;
            if (_this.siteStore.experiments.enabled('specs.stores.RemoveURIJSpp')) {
                return (prefix +
                    (Object.keys(_this.siteStore.location.query).length ? "?" + queryToString(_this.siteStore.location.query) : ''));
            }
            else {
                return new UrlParser(prefix).generate({}, _this.siteStore.location.query);
            }
        };
        paginationMap.forEach(function (slug, index) {
            if (slug === _this.product.urlPart) {
                if (paginationMap[index - 1]) {
                    prevProduct = {
                        partialUrl: paginationMap[index - 1],
                        fullUrl: getUrl(paginationMap[index - 1]),
                    };
                }
                if (paginationMap[index + 1]) {
                    nextProduct = {
                        partialUrl: paginationMap[index + 1],
                        fullUrl: getUrl(paginationMap[index + 1]),
                    };
                }
            }
        });
        return {
            nextProduct: nextProduct,
            prevProduct: prevProduct,
        };
    };
    Object.defineProperty(ProductPageStore.prototype, "slug", {
        get: function () {
            var dirtySlug = decodeURIComponent(this.siteStore.location.path[this.siteStore.location.path.length - 1]);
            return dirtySlug.split('?')[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductPageStore.prototype, "quantityRange", {
        get: function () {
            var qunatities = QuantityCalculator.getQuantitiesRange(this.product, this.userInputs
                .selection);
            return { max: qunatities[qunatities.length - 1], min: qunatities[0] };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductPageStore.prototype, "selectedQuantity", {
        get: function () {
            return this.userInputs.quantity[0];
        },
        enumerable: true,
        configurable: true
    });
    ProductPageStore.prototype.getNavigationContext = function () {
        var context;
        try {
            context = JSON.parse(this.siteStore.storage.local.getItem(STORAGE_PAGINATION_KEY));
        }
        catch (_a) {
            //
        }
        return context || { pageId: undefined, paginationMap: [] };
    };
    Object.defineProperty(ProductPageStore.prototype, "productUrl", {
        get: function () {
            return this.sectionUrl + "/" + this.slug;
        },
        enumerable: true,
        configurable: true
    });
    return ProductPageStore;
}());
export { ProductPageStore };
//# sourceMappingURL=ProductPageStore.js.map